export default "__VITE_ASSET__CnSBfyWG__"